import styled from 'styled-components';

const Close = styled.img`
  position: fixed;
  box-sizing: border-box;
  transform: scaleY(-1);
  cursor: pointer;
`;

export default Close;



// WEBPACK FOOTER //
// ./src/components/CloseBtn/index.jsx